module.exports = {"371322001":"郯城街道","371322101":"马头镇","371322102":"重坊镇","371322103":"李庄镇","371322105":"杨集镇","371322107":"港上镇","371322108":"高峰头镇","371322109":"庙山镇","371322111":"红花镇","371322112":"胜利镇","371322202":"花园乡","371322203":"归昌乡","371322205":"泉源乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371322.json
// module id = 1345
// module chunks = 0